import { Reducer } from 'redux';
import {
  BrokerActionTypes,
  BrokerState,
  GET_BROKER,
  GET_BROKER_LIST,
  POST_BROKER,
  PUT_BROKER
} from '../types/broker.types';

const initialState: BrokerState = {
  brokers: [],
  selectedBroker: null,
  postSuccess: null,
  lastFetch: null,
  totalElements: 0,
  totalPages: 1
};

export const brokerReducer: Reducer<BrokerState> = (
  state: BrokerState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as BrokerActionTypes).type) {
    case GET_BROKER_LIST:
      return {
        brokers: action.payload.page.content,
        selectedBroker: null,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalElements: action.payload.page.totalElements,
        totalPages: action.payload.page.totalPages
      };
    case GET_BROKER:
      return {
        ...state,
        postSuccess: null,
        selectedBroker: action.payload.selectedBroker,
        lastFetch: timeOfAction
      };
    case POST_BROKER:
      return {
        ...state,
        postSuccess: true,
        selectedBroker: action.payload.newBroker,
        lastFetch: timeOfAction
      };
    case PUT_BROKER:
      return {
        ...state,
        selectedBroker: action.payload.selectedBroker,
        postSuccess: true,
        lastFetch: timeOfAction
      };

    default:

      return state;
  }
};
